import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { BaseInlineUpdateComponent, BaseUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EOtpremnicaStavka } from './eotpremnica-stavka';
import { EOtpremnicaStavkaUpdateComponent } from './eotpremnica-stavka-update.component';
import { Observable, of } from 'rxjs';
@Component({
  selector: 'yt-eotpremnica-stavka-inline-update',
  templateUrl: './eotpremnica-stavka-inline-update.component.html'
})
export class EOtpremnicaStavkaInlineUpdateComponent
  extends BaseInlineUpdateComponent<EOtpremnicaStavka> {
  constructor(protected inlineContainerService: InlineContainerService<EOtpremnicaStavka>
       ,private ngZone: NgZone

  ) {
    super(inlineContainerService);
  }
//   @ViewChild('baseUpdate', { static: false })
//   innerUpdateComponent: EOtpremnicaStavkaUpdateComponent;


// Reset() {
//     if (this.innerUpdateComponent?.base) {
//         this.innerUpdateComponent.base
//             .Reset(false)
//             .subscribe(result => {
//                 console.log("RESET gornji, result:", result);
//             });
//     }
// }








toggleCollapse() {
    this.collapsed = !this.collapsed;
}

// ngAfterViewInit() {
//     console.log("VIEW INIT => innerUpdateComponent =", this.innerUpdateComponent);
// }
}
